import { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { routePaths } from 'router';
import { useGetManyCargos } from 'api/cargos/use-get-many-cargos.ts';
import { useMoveToPath } from 'shared/hooks/use-move-to-path';
import { useCargoFiltersStore } from 'shared/stores/use-cargo-filters.ts';
import { SearchFilter } from 'components/common/search-filter';
import styles from './cargo-filters-search.module.scss';

export const CargoFiltersSearch = () => {
  const [options, setOptions] = useState<{ label: React.ReactNode; value: number }[]>([]);
  const [searchString, setSearchString] = useState('');
  const { moveToPath } = useMoveToPath();

  const { setSearch } = useCargoFiltersStore();
  const { data: cargos, isError } = useGetManyCargos({
    limit: 10,
    search: searchString,
    isHints: true,
    isSkip: !searchString,
  });

  useEffect(() => {
    if (cargos && !isError) {
      const values = cargos.data.map((cargo) => ({
        label: (
          <>
            <Typography.Text strong>{cargo.compositeId}</Typography.Text>
            <Typography.Text className={styles.hintSecondaryInfo}>
              {' '}
              {cargo.order.compositeId}
              {cargo.order.clientOrderNumber ? ` - ${cargo.order.clientOrderNumber}` : ''}
            </Typography.Text>
          </>
        ),
        value: cargo.id,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [cargos, isError]);

  const handleSelect = (value: string) => {
    moveToPath(routePaths.cargo, { cargoId: value });
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={handleSelect}
    />
  );
};
